<template>
  <v-dialog
    v-model="open"
    :disabled="!totalIngressosDisponiveis"
    max-width="1020"
    persistent
  >
    <template v-slot:activator="dialog">
      <v-tooltip bottom color="primary">
        <template v-slot:activator="tooltip">
          <v-btn
            color="primary"
            outlined
            block
            v-bind="{...dialog.attrs, ...tooltip.attrs}"
            :loading="ingressos.length === 0"
            v-on="{...dialog.on, ...tooltip.on}"
          >
            Titularidade do ingresso
          </v-btn>
        </template>

        <span v-if="totalIngressosDisponiveis">
          Existem {{ totalIngressosDisponiveis }} ingressos<br> disponíveis para<br> edição.
        </span>

        <span v-else>
          Todos os ingressos<br> disponíveis já<br> foram editados.
        </span>
      </v-tooltip>
    </template>


    <v-card class="grey lighten-3 d-flex flex-row">
      <v-icon class="botao-fechar" @click="open = false">
        mdi-close
      </v-icon>

      <TitularidadeIngressoTabs
        v-show="desktop || !ingressoSelecionado"
        :ingressos="ingressos"
        @change="ingressoAlterado"
      />

      <TitularidadeIngressoForm
        v-if="ingressoSelecionado && ingressoSelecionado.remaining_changes > 0"
        v-show="!dadosNovaTitularidade"
        :ingresso="ingressoSelecionado"
        @submit="setDadosNovaTitularidade"
        @cancel="ingressoSelecionado = null"
      />

      <TitularidadeIngressoView
        v-else
        v-show="!dadosNovaTitularidade"
        :ingresso-selecionado="ingressoSelecionado"
        @cancel="ingressoSelecionado = null"
      />

      <TitularidadeIngressoConfirmacao
        v-if="dadosNovaTitularidade"
        :dados-nova-titularidade="dadosNovaTitularidade"
        @saved="titularidadeSalva"
        @cancel="dadosNovaTitularidade = null"
        @error="mostrarErro"
      />

    </v-card>

    <SnackBar
      :mensage="snackBar.message"
      :snackbar="snackBar.show"
      :color="snackBar.color"
      @changeSnackBar="({visible}) => snackBar.show = visible"
    />
  </v-dialog>
</template>

<script>
import ApiIngressos from '@/api/ingressos';
import TitularidadeIngressoTabs from './TitularidadeIngressoTabs.vue';
import TitularidadeIngressoForm from './TitularidadeIngressoForm.vue';
import TitularidadeIngressoConfirmacao from './TitularidadeIngressoConfirmacao.vue';
import TitularidadeIngressoView from './TitularidadeIngressoView.vue';
import SnackBar from '../../SnackBar.vue';

export default {
  name: 'TitularidadeIngresso',
  components: {
    TitularidadeIngressoTabs,
    TitularidadeIngressoForm,
    TitularidadeIngressoConfirmacao,
    TitularidadeIngressoView,
    SnackBar,
  },
  props: {
    venda: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    open: false,
    ingressos: [],
    dadosNovaTitularidade: null,
    ingressoSelecionado: null,
    totalIngressosDisponiveis: 0,
    snackBar: {
      show: false,
      message: '',
      color: 'error',
    },
  }),

  async created() {
    this.buscarTitularidade();
  },

  methods: {
    buscarTitularidade() {
      ApiIngressos.buscarTitularidade(this.venda)
        .then(({ data }) => {
          this.dadosNovaTitularidade = null;
          this.ingressos = data;

          if (!this.desktop) {
            this.ingressoSelecionado = null;
          }

          if (this.ingressoSelecionado) {
            this.ingressoAlterado(this.ingressoSelecionado.id);
          }

          const ingressosDisponiveis = data.filter(ingresso => ingresso.remaining_changes > 0);

          if (!ingressosDisponiveis.length) {
            this.open = false;
          }

          this.totalIngressosDisponiveis = ingressosDisponiveis.length;
        })
        .catch(() => this.mostrarErro());
    },

    ingressoAlterado(ingressoAtual) {
      this.ingressoSelecionado = this.ingressos.find(ingresso => ingresso.id === ingressoAtual);
    },

    setDadosNovaTitularidade(form) {
      this.dadosNovaTitularidade = form;
    },

    titularidadeSalva() {
      this.buscarTitularidade();

      this.snackBar.message = 'Titularidade salva com sucesso.';
      this.snackBar.color = 'success';
      this.snackBar.show = true;
    },

    mostrarErro(mensagem = '') {
      this.snackBar.message = mensagem || 'Ocorreu um erro inesperado, tente novamente mais tarde.';
      this.snackBar.color = 'error';
      this.snackBar.show = true;

      this.dadosNovaTitularidade = null;
      this.ingressoSelecionado = null;
    },
  },
};
</script>

<style scoped>
.botao-fechar {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}
</style>
